function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#F7F7FB",
  d: "M28.85 32.95h-16.3c-6 0-10.9-4.85-10.9-10.85s4.9-10.9 10.9-10.9H28.9"
}), React.createElement("path", {
  fill: "#C7D7E2",
  d: "M39.75 41.1c0-6-4.9-8.15-10.9-8.15V11.2c6 0 10.9-2.15 10.9-8.15h2.7V41.1h-2.7z"
}), React.createElement("path", {
  fill: "#DFE0E4",
  d: "M28.85 27h-16.3c-5 0-9.15-3.35-10.5-7.85-.1.4-.2.85-.3 1.3v.05c0 .1-.05.2-.05.3 0 .15-.05.3-.05.45V22.15c0 6 4.9 10.85 10.9 10.85h16.3v-6z"
}), React.createElement("path", {
  fill: "#98BED8",
  d: "M41.3 35.15c-.05-6-6.45-8.15-12.45-8.15v5.95c6 0 10.95 2.15 10.95 8.15h1.45l.05-5.95z"
}), React.createElement("path", {
  fill: "#E4CAA6",
  d: "M12.55 32.95c1.35 0 2.45 1.1 2.45 2.45v10.5c0 1.8 1.4 3.35 3.15 3.4 1.85.05 3.35-1.45 3.35-3.25V35.4c0-1.35 1.1-2.45 2.45-2.45"
}), React.createElement("path", {
  fill: "#CEB797",
  d: "M23.95 32.95h-11.4c1.35 0 2.45 1.1 2.45 2.45v2.15h6.5V35.4c0-1.35 1.1-2.45 2.45-2.45z"
}), React.createElement("path", {
  fill: "#464C55",
  d: "M57.9 23.6H53c-.85 0-1.5-.65-1.5-1.5s.65-1.5 1.5-1.5h4.9c.85 0 1.5.65 1.5 1.5s-.65 1.5-1.5 1.5zm-6.15-5.45c-.45 0-.85-.2-1.15-.55-.55-.65-.45-1.6.2-2.1l3.25-2.7c.65-.55 1.6-.45 2.1.2.55.65.45 1.6-.2 2.1l-3.25 2.7c-.25.2-.6.35-.95.35zM55 31.75c-.35 0-.7-.1-.95-.35l-3.25-2.7c-.65-.55-.7-1.5-.2-2.1.55-.65 1.5-.7 2.1-.2l3.25 2.7c.65.55.7 1.5.2 2.1-.3.35-.7.55-1.15.55zm-5.55-9.65c0-3.35-2.35-6.1-5.45-6.8V3.05C44 1.5 42.75.2 41.15.2 39.6.2 38.3 1.45 38.3 3.05c0 4.4-3.15 6.65-9.4 6.65H12.55C5.7 9.7.15 15.3.15 22.1c0 6.8 5.55 12.35 12.4 12.35.55 0 .95.45.95.95v10.5c0 2.6 2.05 4.8 4.6 4.9h.15c1.25 0 2.45-.5 3.35-1.4.9-.9 1.4-2.1 1.4-3.35v-6.3c2.65-.6 4.7-2.65 5.3-5.3h.55c6.25 0 9.4 2.25 9.4 6.65 0 .2.05.35.1.5a2.81 2.81 0 0 0 2.8 2.4C42.7 44 44 42.7 44 41.1V28.9c3.1-.7 5.45-3.45 5.45-6.8zm-29.5 13.3v10.65c0 .45-.15.95-.5 1.25-.35.3-.8.5-1.25.5h-.05c-.95 0-1.7-.9-1.7-1.9V35.4c0-.35-.05-.65-.1-.95h3.7c-.05.3-.1.65-.1.95zM23 36.6v-1.2c0-.55.45-.95.95-.95h1.2c-.4 1-1.15 1.75-2.15 2.15zm18 2.15c-1.05-4.65-5.35-7.25-12.15-7.25h-16.6a9.36 9.36 0 0 1-8.95-7.9h2.95c.8 0 1.5-.65 1.5-1.5s-.65-1.5-1.5-1.5H3.3c.1-.55.2-1.1.4-1.6h3.9c.85 0 1.5-.65 1.5-1.5S8.45 16 7.6 16H5.4c1.7-2 4.3-3.3 7.15-3.3H27.4v7.65c0 .85.65 1.5 1.5 1.5s1.5-.65 1.5-1.5v-7.7c5.85-.35 9.55-2.9 10.6-7.15v33.25zm3-13v-7.3c1.45.6 2.45 2 2.45 3.65s-1 3.05-2.45 3.65z"
}));

var SvgCommercialExtra = function SvgCommercialExtra(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 51,
    viewBox: "0 0 60 51",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCommercialExtra, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/commercial-extra.20b443dc.svg";
export { ForwardRef as ReactComponent };